export default "__VITE_ASSET__xvktoV8b__"